import React from "react";
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Navigation } from "./components/navigation";
import { Header } from "./components/header";
import { Features } from "./components/features";
import { About } from "./components/about";
import { Services } from "./components/services";
import { Contact } from "./components/contact";
import { TermsConditions } from "./components/TermsConditions";
import { PrivacyPolicy } from "./components/PrivacyPolicy";
import JsonData from "./data/data.json";
import landerdata from "./data/landerdata.json";
import SmoothScroll from "smooth-scroll";
import "./App.css";
import Chatbot from './components/chatbot';
import { Navigation1 } from "./lander/navigation";
import { Header1 } from "./lander/header";
import { Features1 } from "./lander/features";
import { About1 } from "./lander/about";
import { Services1 } from "./lander/services";
import { Gallery1 } from "./lander/gallery";
import { Testimonials1 } from "./lander/testimonials";
import { Team1 } from "./lander/Team";
import { Contact1 } from "./lander/contact";
import DelegateHome, { DocsPage, OperatorPage, PrivacyPage, SafetyPage, TermsPage } from "./delegateSite";

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

const AppWrapper = () => {
  return (
    <Router>
      <App />
    </Router>
  );
};

const App = () => {
  const landingPageData = JsonData;
  const landingPageData1 = landerdata;
  return (
    <>
      <Routes>
        <Route path="/uif" element={<Chatbot />} />
        <Route path="/terms-and-conditions" element={<TermsConditions />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/chatbot" element={
          <>
            <Navigation1 data={landingPageData1} />
            <Header1 data={landingPageData1.Header} />
            <Features1 data={landingPageData1.Features} />
            <About1 data={landingPageData1.About} />
            <Services1 data={landingPageData1.Services} />
            <Gallery1 data={landingPageData1.Gallery} />
            <Testimonials1 data={landingPageData1.Testimonials} />
            <Team1 data={landingPageData1.Team} />
            <Contact1 data={landingPageData1.Contact} />
          </>
        } />
        <Route path="/delegate" element={<DelegateHome />} />
        <Route path="/docs" element={<DocsPage />} />
        <Route path="/safety" element={<SafetyPage />} />
        <Route path="/operator" element={<OperatorPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/delegate/terms" element={<TermsPage />} />
        <Route path="/" element={
          <>
            <Navigation data={landingPageData} />
            <Header data={landingPageData.Header} />
            <Features data={landingPageData.Features} />
            <About data={landingPageData.About} />
            <Services data={landingPageData.Services} />
            <Contact data={landingPageData.Contact} />
          </>
        } />
      </Routes>
    </>
  );
};

export default AppWrapper;
